<div class="getting-started-phase" [class.locked]="phase.locked">
  @if (phase.locked) {
    <div class="phase-locked">
      <terra-icon icon="lock" variant="fill" size="40" />
    </div>
  } @else {
    <div class="phase-image" [style.backgroundImage]="'url(' + phase.image_url + ')'">
      @if (phase.completed) {
        <div class="phase-completed">
          <terra-icon icon="check" variant="bold" size="40" />
        </div>
      }
    </div>
  }

  <div class="phase-details">
    <h2 class="phase-title">{{ phase.ordinal }}. {{ phase.title }}</h2>

    @if (!phase.locked) {
      <p class="phase-description">
        {{ phase.description }}
      </p>
      <div class="steps-completed">
        @if (!phase.completed) {
          <ninety-progress-bar [percentage]="phase.percentageComplete" />
        }
        <div>{{ phase.stepsCompleted }} of {{ phase.steps.length }} steps complete</div>
      </div>
    } @else {
      <p class="phase-description">Complete '{{ previousPhaseTitle }}' to unlock this phase</p>
    }
  </div>
</div>
